<template>
  <div  id="app-bar" >
    <div class="pr-4 handCursor" v-on:click="avatarClicked">
            <span v-if="userInfo && userInfo.name" id="userName">{{ userInfo.name }}</span>
            <h4 id="userRole">{{ userRole }}</h4>
    </div>
    <v-avatar class="handCursor" size="44" v-on:click="avatarClicked">
        <img v-if="userInfo && userInfo.name" class="fitImage"
           v-bind:src="userImage"
           v-bind:alt="userInfo.name"
        >
    </v-avatar>
  </div>
</template>

<script>
import { mapState } from "vuex";
// import { getUserRole, getTextOfUserRole } from "@/utilities/CommonUtilities";
import { ListEvents, DefaultValues } from "@/utilities/CommonUtilities";
export default {
  computed: {
    ...mapState(["userInfo"]),
    userRole() {
      // let userRole = getUserRole(this.userInfo.serviceInformation);
      // let text = getTextOfUserRole(userRole, this.$i18n.locale);
      // return text;
      return this.userInfo != null ? this.userInfo.section : DefaultValues.none_string;
    },
    userImage() {
      if (this.userInfo && this.userInfo.profiolePhoto != null) {
        return `data:image/png;base64,${this.userInfo.profiolePhoto}`;
      } else {
        return DefaultValues.no_image;
      }
    }
  },
  methods: {
    avatarClicked() {
      this.notifyBus.$emit(ListEvents.showRightMenu);
    }
  },
  inject: ["notifyBus"]
};
</script>

<style scoped>
#app-bar {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  opacity: 1;
  background-color: white;
  height: 70px !important;
}
#userName {
  font-size: 14px;
  position: static;
  font-weight: 800;
  color: #333333;
}
#userRole {
  align-content: flex-end;
  font-size: 12px;
  font-weight: 400;
  text-align: right;
  position: static;
  color: #c7c7c7;
}
.fitImage {
    object-fit: cover;
}
.handCursor { cursor: pointer; }
</style>

